<template>
  <div>

    <vx-card card-border class="mb-4" title="Datos del cliente" title-color="dark" collapseAction>
      <div class="vx-row mb-2">
        <div class="vx-col sm:w-1/2 w-full">
          <div>
            <span>DNI/CIF</span>
          </div>
          <div>
            <vs-input data-vv-as="DNICliente" v-validate="'required|alpha_num|checkDNI'" name="dniCliente" v-model="cliente.dni" disabled/>
          </div>
        </div>
        <div class="vx-col sm:w-1/2 w-full">
          <div>
            <span>Fecha nacimiento</span>
          </div>
          <div>
            <flat-pickr name="fechaNacimiento" :config="configdateTimePicker" v-model="cliente.fechaNacimiento" />
          </div>
        </div>
      </div>
      <div class="vx-row mb-2">
        <div class="vx-col sm:w-1/2 w-full">
          <div>
            <span class="campoObligatorio">Nombre o razón social *</span>
          </div>
          <div>
            <vs-input class="w-full" data-vv-as="NOMBRE" v-validate="'required'" name="nombreCliente" v-model="cliente.nombre" @input="v => { cliente.nombre = v.toUpperCase()}" />
            <span class="text-danger text-sm"  v-show="errors.has('nombreCliente')">{{ errors.first('nombreCliente') }}</span>
          </div>
        </div>
        <div class="vx-col sm:w-1/2 w-full">
          <div>
            <span>Apellidos</span>
          </div>
          <div>
            <vs-input class="w-full" name="apellidos" v-model="cliente.apellidos" @input="v => { cliente.apellidos = v.toUpperCase()}" />
          </div>
        </div>
      </div>

      <!-- Save & Reset Button -->
      <div class="vx-row">
        <div class="vx-col w-full">
          <div class="mt-8 flex flex-wrap items-center justify-end">
            <vs-button class="ml-auto mt-2" @click="guardar" :disabled="!validateForm">Guardar</vs-button>
            <vs-button class="ml-4 mt-2" type="border" color="warning" @click="reset_data">Cancelar</vs-button>
          </div>
        </div>
      </div>
    </vx-card>

    <vx-card card-border class="mb-4" title="Operaciones relacionadas" title-color="dark" collapseAction>

      <vx-card class="mb-2">
        <vs-row>
          <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="2">
            <span class="text-warning font-bold">ID OPERACIÓN</span>
          </vs-col>
          <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="2">
            <span class="text-warning font-bold">RELACIÓN</span>
          </vs-col>
          <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="2">
            <span class="text-warning font-bold">FECHA</span>
          </vs-col>
          <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="2">
            <span class="text-warning font-bold">OPERADOR</span>
          </vs-col>
          <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="3">
            <span class="text-warning font-bold">ESTADO</span>
          </vs-col>
          <vs-col vs-type="flex" vs-justify="flex-end" vs-align="center" vs-w="1">
            &nbsp;
          </vs-col>
        </vs-row> 
      </vx-card>

      <vx-card card-border class="mb-2" v-for="(op, index) in operacionesSinDuplicados" :key="index">

          <vs-row>
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="2">
              <span class="cursor-pointer text-primary" @click="irAOperacion('ver', op.operacionId)">
                {{op.operacionId}}
              </span>
            </vs-col>
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="2">
              <span class="cursor-pointer text-primary" @click="irAOperacion('ver', op.operacionId)">
                {{op.relacion}}
              </span>
            </vs-col>
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="2">
              <span class="cursor-pointer text-primary" @click="irAOperacion('ver', op.operacionId)">
                {{op.fecha | date}}
              </span>
            </vs-col>
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="2">
              <span class="cursor-pointer text-primary" @click="irAOperacion('ver', op.operacionId)">
                {{op.operador}}
              </span>
            </vs-col>
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="3">
              <span class="cursor-pointer text-primary" @click="irAOperacion('ver', op.operacionId)">
                {{op.estado}}
              </span>
            </vs-col>
            <vs-col vs-type="flex" vs-justify="flex-end" vs-align="center" vs-w="1">
              <feather-icon icon="Edit3Icon" class="mr-4 hover:text-primary cursor-pointer" @click="irAOperacion('editar', op.operacionId)"/>
            </vs-col>
          </vs-row>       

      </vx-card>
    </vx-card>

  </div>
</template>

<script>
import personasStore from '@/store/gestion/personas/index.js'
import operacionesStore from '@/store/gestion/operaciones/index.js'

import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import {Spanish as SpanishLocale} from 'flatpickr/dist/l10n/es.js'

export default {
  name: 'ClientesEdit',
  components: {
    flatPickr,
    SpanishLocale
  },
  data () {
    return {
      cliente: {},

      //Flat Date Picker
      configdateTimePicker: {
        locale: SpanishLocale,
        altInput: true,  // para que mostre ao usuario a data nun formato e devolva ao servidor un formato distinto (altFormat)
        altFormat: 'd/m/Y',
        dateFormat: 'Y-m-d',
        mode: 'single',
        defaultDate: null,
        wrap: true
      }
    }
  },
  computed: {
    validateForm () {
      if (this.errors.any() || this.cliente.dni === null || this.cliente.dni === undefined 
        || this.cliente.nombre === null || this.cliente.nombre === undefined) {
        return false
      } else {
        return true
      }
    },
    operacionesSinDuplicados () {
      const o = JSON.parse(JSON.stringify(this.cliente.operacionPersonas))
      const operaciones = []
      let idx = -1

      o.forEach(element => {
        if (operaciones.length > 0) idx = operaciones.findIndex((e) => e.operacionId === element.operacion.id) // Buscamos se o id da operación xa existe no array
        if (idx === -1) {  // No caso de que esa operación non exista no array, introducímola
          const e = { 
            'operacionId': element.operacion.id, 
            'relacion': element.relacion, 
            'fecha': element.operacion.fecha, 
            'operador': element.operacion.operador, 
            'estado': element.operacion.valEstado.estado
          }
          operaciones.push(e)
        } else {
          operaciones[idx].relacion = `${operaciones[idx].relacion} / ${element.relacion}`
        }
      })

      return operaciones
    }
  },
  methods: {
    async guardar () {
      if (!this.validateForm) return
      this.$vs.loading('material') // Mostramos unha animación de 'cargando...'
      
      const c = {}
      c.id = this.cliente.id
      c.nombre = this.cliente.nombre
      c.apellidos = this.cliente.apellidos
      c.fechaNacimiento = this.cliente.fechaNacimiento

      await this.$store.dispatch('personasStore/updatePersona', c)
        .then(() => {
          this.cliente = JSON.parse(JSON.stringify(this.$store.state.personasStore.persona))
          this.showUpdateSuccess('CLIENTE ACTUALIZADO', 'Los datos del cliente han sido guardados correctamente.')
        })
        .catch((error) => {
          this.showUpdateError(error)
        })
    },
    showUpdateSuccess (titulo, texto) {
      this.$vs.loading.close()  // Pechamos a animación de 'cargando...'
      this.$vs.notify({
        color: 'success',
        title: titulo,
        text: texto
      })
    },
    showUpdateError (error) {
      this.$vs.loading.close()  // Pechamos a animación de 'cargando...'
      this.$vs.notify({
        color: 'danger',
        title: 'ERROR',
        text: error
      })
    },
    reset_data () {
      this.$router.push({name: 'clientes'})
    },
    async irAOperacion (accion, operacion) {
      this.$vs.loading('material') // Mostramos unha animación de 'cargando...'
      try {
        if (!operacionesStore.isRegistered) {
          this.$store.registerModule('operacionesStore', operacionesStore)
          operacionesStore.isRegistered = true
        }

        await this.$store.dispatch('operacionesStore/getOperacion', operacion)
      } catch (error) {
        console.error(error)
      }
      const ruta = `/gestion/operaciones/${accion}/${operacion}`
      this.$router.push(ruta).catch(() => {})
    }
  },
  created () {
    if (!personasStore.isRegistered) {
      this.$store.registerModule('personasStore', personasStore)
      personasStore.isRegistered = true
    }

    this.cliente = JSON.parse(JSON.stringify(this.$store.state.personasStore.persona))
    this.$vs.loading.close()  // Pechamos a animación de 'cargando...'
  }
}
</script>

